import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Company} from 'main/stores/users';

class MicrosoftCredentials extends DomainObject {
  organizationDomains;
  organizationName;
  company;

  _relations = {
    company: Company
  };

  constructor(other) {
    super();

    makeObservable(this, {
      organizationDomains: observable,
      organizationName: observable,
      company: observable
    });

    this.merge(other);
  }
}

export default MicrosoftCredentials;
